import {BaseViewModel} from '../../../../../models/base/base-view-model';
import {Injectable, OnDestroy} from '@angular/core';

@Injectable()
export class CompanyPendingViewModel extends BaseViewModel implements OnDestroy {

  constructor(
  ) {
    super();
  }

  ngOnDestroy() {
    this.destroy();
  }

}
